import React, { FC } from "react";

import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { TextInput } from "@/components/atoms";
import { FormPanel } from "@/components/organisms";

import { CustomerCardFormType } from "../../../../formType";

const SpreadPanel: FC = () => {
    const { t } = useTranslation();
    const { control } = useFormContext<CustomerCardFormType>();

    return (
        <FormPanel title={t("CustomerDetails.General.Spread")} mode="edit">
            <TextInput
                autoComplete="off"
                label={t("CustomerCard.PersonalInfo.SpreadComment")}
                multiline
                maxRows={6}
                minRows={6}
                name="officeAwareness.comment"
                control={control}
            />
        </FormPanel>
    );
};

export default SpreadPanel;
